import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { LatestVideos } from './components/LatestVideos';
import { ShortsRow } from './components/ShortsRow';
import { RouteMap } from './components/RouteMap';
import { TopVideos } from './components/TopVideos';
import { Playlists } from './components/Playlists';
import { VideoArchive } from './components/VideoArchive';
import { AboutAuthor } from './components/AboutAuthor';
import { SubscribeBand } from './components/SubscribeBand';
import { SiteFooter } from './components/SiteFooter';
import { playlists } from './data/playlists';
import { longForm, mappedVideos, shorts, topVideos } from './utils/videoLists';
const [featured, ...others] = longForm;
export function App() {
  return <div className="min-h-screen w-full bg-ink text-paper" data-id="element-0" data-mp="28tw5osok2m3z">
      <SiteHeader data-id="element-1" data-mp="28sb9yzqi8x4j" />
      <main data-id="element-2" data-mp="23vchsmqej08z">
        <Hero video={featured} data-id="element-3" data-mp="23vuo6c6s2uum" />
        <LatestVideos videos={others.slice(0, 4)} data-id="element-4" data-mp="23ujmchww7x65" />
        <ShortsRow shorts={shorts.slice(0, 12)} data-id="element-5" data-mp="3ijxoypkvdyjd" />
        <RouteMap videos={mappedVideos} data-id="element-6" data-mp="3ij61y35c994p" />
        <TopVideos videos={topVideos.slice(0, 5)} data-id="element-7" data-mp="3mlj9mx3nbh44" />
        <Playlists playlists={playlists} videos={longForm} data-id="element-8" data-mp="3mk852v2dm5by" />
        <VideoArchive videos={longForm} data-id="element-9" data-mp="3rcj8i7wbs999" />
        <AboutAuthor data-id="element-10" data-mp="3rdkkqfp2v1sk" />
        <SubscribeBand data-id="element-11" data-mp="3recedkz46pg7" />
      </main>
      <SiteFooter data-id="element-12" data-mp="6hqffdy0fe4" />
    </div>;
}